import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from '../styles/components/widget-template.module.scss';
import { PageAction } from './page-actions-section/components/page-action';

const TWidgetButtonLink = ({ iconName, onClick, linkText = 'Page Action', linkURL, type, className }) => (
  <div className={classnames(styles.wrapper, className)}>
    <PageAction isButton={!!onClick} onClick={onClick} iconName={iconName} to={linkURL} type={type}>
      {linkText}
    </PageAction>
  </div>
);

TWidgetButtonLink.propTypes = {
  linkText: PropTypes.string.isRequired,
  linkURL: PropTypes.string.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
  iconName: PropTypes.string,
  onClick: PropTypes.func
};

export default TWidgetButtonLink;
